<template>
    <div :class="`a-subscriber-container columns mx-2 ${hasSubscriptionClass}`">
        <settings-sidebar :active-menu-item="'advertisement'"
                          class="column is-3 py-2 mr-md-3 mb-3 mb-md-auto">
        </settings-sidebar>

        <div v-if="userSubscriptions.length" class="container-lg column is-multiline m-0  mt-sm-4 mt-md-3 mt-lg-0 p-0">
            <dropzone />

            <div v-if="false" class="bg-white mt-3 py-4 pl-4 pr-md-16 pr-4 border-radius">
                <h1 class="mb-3 fs-28">Your advert subscription</h1>
                <p class="mb-4">You can cancel your advertisement subscription at anytime but please be aware that as soon as your subscription
                    is cancelled your advert will be removed from the website immediately regardless of where you are in the current
                    billing cycle.</p>
                <a v-if="!loading" @click="cancel" class="cancel-subscription font-weight-bold fs-18">Cancel subscription</a>
                <pulse-loader v-if="loading" :loading="true" :color="'#143642'" :size="'10px'"></pulse-loader>
            </div>
        </div>

        <cat-uxo-advertisement v-else
                               :active-users="activeUsers"
                               :plans="plans">

        </cat-uxo-advertisement>

    </div>
</template>

<script>
    import SettingsSidebar from '../../shared/SettingsSidebar';
    import Dropzone from '../../Dropzone';
    import {axiosApi, axiosWeb} from "@/js/axios";
    import Advertisement from "../../Advertisement";
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

    export default {
        name: 'CatUxoPageAdvertisement',
        components: {
            SettingsSidebar,
            Dropzone,
            Advertisement,
            PulseLoader,
        },
        data: function () {
            return {
                error: [],
                loading: false,
            }
        },
        props: {
            user: {
                type: Object,
                required: true
            },
            userSubscriptions: {
                type: Array,
                required: true
            },
            plans:{
                type: Array,
                required: true
            },
            activeUsers: {
                type: String,
                required: false
            },
        },
        computed:{
          hasSubscriptionClass() {
              return this.userSubscriptions.length ? "has-subscription" : '';
          }
        },
        methods:{
            cancel() {
                const $this = this;

                var confirmation = window.confirm("Are you sure you want to cancel? Your advert will be removed from the website immediately regardless of where you are in the current billing cycle.");
                if (confirmation === true) {

                    $this.loading = true;

                    return axiosWeb.post(`/api/v1/a-subscription/cancel`).then(response => {
                        let toast = Vue.toasted.show("Your subscription has been canceled.", {
                            theme: "toasted-primary",
                            type: 'success',
                            icon: 'done',
                            position: "top-center",
                            duration: 6000,
                            className: 'shadow-modal rounded-lg font-primary p-2',
                        });
                        setTimeout(function () {
                            window.location.href = '/settings/advertisement';
                        }, 2000);
                    }).catch((error) => {
                        $this.loading = false;
                        this.error = error.response.data;
                        let toast = Vue.toasted.show(this.error, {
                            theme: "toasted-primary",
                            type: 'error',
                            icon: 'close',
                            position: "top-center",
                            duration : 6000,
                            className: 'shadow-modal rounded-lg font-primary p-2',
                        });
                        setTimeout(() => this.errors = false, 3000);
                    })
                }
            }
        }
    }

</script>

<style lang="scss" scoped>
    .has-subscription{
        flex-wrap: wrap;
    }

    .cancel-subscription{
        text-decoration: underline;
    }
    .column.is-8{
        width: 73%;
    }

    @media (max-width: 1270px){
        .has-subscription {
                flex-direction: column;

            >.container-lg {
                margin-top: 20px !important;
            }
        }
    }
    @media (min-width: 992px){

        .pr-md-16{
            padding-right: 16rem;
        }
    }

</style>



// WEBPACK FOOTER //
// resources/js/components/pages/settings/Advertisement.vue